import React, { Component } from 'react';
import { TabContent, Alert, TabPane, Card, CardHeader, CardBody, Spinner, NavItem, NavLink, Nav, NavbarToggler, Form, FormGroup, Label, Row, Col, Input, Button, Navbar, Collapse } from 'reactstrap';
import { withRouter, Switch } from 'react-router';
import _ from 'underscore';
import moment from 'moment';
import { Global } from '~/App'
import API from '~/API';
import { Link } from 'react-router-dom';
import IngresaCuenta from '~/components/IngresaCuenta'
import Login from '~/Usuario/Login'

class Detalle extends Component {
    constructor() {
        super();
        this.state = {
            collapsed: false,
            Convenios: null,
            medidorDetalles: null
        }
    }
    componentWillMount() {
        var matches = this.props.location?.search?.match(/empresa=([^&]*).*?servicio=([^&]*)(.*seccion=([^&]*))*/i) || []
        if (matches.length >= 3) {
            var Empresa = Global.empresas.find(o => o.key == matches[1])
            this.props.history.replace({
                pathname: "/detalle"+(matches[4] ? ("/"+matches[4]) : ""),
                state: { servicio: { empresa: matches[1], idServicio: matches[2], Empresa, nombreEmpresa: Empresa.nombre } }
            })
        } else {
            this.Redirect(this.props);
            this.consultaConvenios(this.props);
            this.consultaMedidor(this.props);
        }
    }
    componentDidUpdate(prevProps) {
        var Servicio = (prevProps.location.state || {}).servicio;
        var ServicioN = (this.props.location.state || {}).servicio;
        if (Servicio?.idServicio !== ServicioN?.idServicio) {
            this.setState({ Convenios: null, medidorDetalles: null });
            if (ServicioN?.idServicio && ServicioN?.empresa) {
                this.consultaConvenios(this.props);
                this.consultaMedidor(this.props);
            }
        }
        this.Redirect(this.props);
    }
    async consultaMedidor(props) {
        var Servicio = (props.location.state || {}).servicio;
        if (!Servicio || !Servicio.idServicio || !Servicio.empresa) {
            return;
        }
        try {
            const medidorData = await API.Call(`Consulta/${Servicio.empresa}/Medidor/Info/${Servicio.idServicio}`);
            this.setState({ medidorInfo: medidorData });
        } catch (error) {
            console.error("Error fetching meter info in Detail/index.js:", error);
            this.setState({ medidorInfo: null }); // Reset on error
        }
    }
    async consultaConvenios(props) {
        var Servicio = (props.location.state || {}).servicio
        if (!Servicio.idServicio || !Servicio.empresa) {
            return;
        }
        if (!this.state.Convenios) {
            var Convenios = await API.Call(`Consulta/${Servicio.empresa}/Convenios/${Servicio.idServicio}`);
            this.setState({ Convenios });
        }
    }
    Redirect(props) {
        if (!props.location.state || !props.location.state.servicio || (props.Usuario && !props.Servicios.some(e => e.empresa?.toLowerCase() == props.location.state.servicio.empresa?.toLowerCase() && e.idServicio == props.location.state.servicio.idServicio))) {
            props.history.replace("/sucursal");
        }
    }
    render() {
        var servicio = this.props.location.state ? this.props.location.state.servicio : {};
        servicio = { ...servicio, Empresa: servicio.Empresa ? servicio.Empresa : Global.empresas.find(o => o.key == servicio.empresa) }
        
        const path = this.props.location.pathname;
        const isCurrent = (p) => path.endsWith(p) || (p === '/documentos' && path.endsWith('/detalle'));

        var Navegacion = (
            <Nav vertical className="detalle-nav">
                <NavItem>
                    <NavLink tag={Link} to={{ pathname: "/detalle/documentos", state: { servicio } }} active={isCurrent('/documentos')}>
                        <i className="fa fa-file-text-o mr-2" /> Documentos
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink tag={Link} to={{ pathname: "/detalle/cartas", state: { servicio } }} active={isCurrent('/cartas')}>
                        <i className="fa fa-envelope-open-o mr-2" /> Cartas y Notificaciones
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink tag={Link} to={{ pathname: "/detalle/pagos", state: { servicio } }} active={isCurrent('/pagos')}>
                        <i className="fa fa-money mr-2" /> Pagos
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink tag={Link} to={{ pathname: "/detalle/consumos", state: { servicio } }} active={isCurrent('/consumos')}>
                        <i className="fa fa-bar-chart mr-2" /> Consumos
                    </NavLink>
                </NavItem>
                {servicio.e_mail !== undefined && <NavItem>
                    <NavLink tag={Link} to={{ pathname: "/detalle/email", state: { servicio } }} active={isCurrent('/email')}>
                        <i className="fa fa-envelope-o mr-2" /> Envío por E-Mail
                    </NavLink>
                </NavItem>}
                {(this.state.Convenios || []).length > 0 && <NavItem>
                    <NavLink tag={Link} to={{ pathname: "/detalle/convenios", state: { servicio } }} active={isCurrent('/convenios')}>
                        <i className="fa fa-handshake-o mr-2" /> Mis Convenios
                    </NavLink>
                </NavItem>}
                {servicio.Empresa?.otros?.Requerimientos !== undefined ? <NavItem>
                    <NavLink tag={Link} to={{ pathname: "/detalle/requerimientos", state: { servicio } }} active={isCurrent('/requerimientos')}>
                        <i className="fa fa-bullhorn mr-2" /> Mis Requerimientos
                    </NavLink>
                </NavItem> : null}
                {servicio.Empresa?.otros?.Suscripciones !== undefined ? <NavItem>
                    <NavLink tag={Link} to={{ pathname: "/detalle/suscripciones", state: { servicio } }} active={isCurrent('/suscripciones')}>
                        <i className="fa fa-refresh mr-2" /> Mis Pagos Automáticos
                    </NavLink>
                </NavItem> : null}
            </Nav>
        )

        if(!servicio || !servicio.idServicio) return <Spinner animation="border" role="status">Cargando...</Spinner>
        
        if (!this.props.Usuario) {
            return <Card>
                <CardHeader className="titulo-modal">Sucursal Virtual</CardHeader>
                <CardBody className="cuerpo-modal">
                    <Row>
                        <Col sm={{ size: 6, offset: 3 }} className="bordeCompleto">
                            <h4 className="text-muted"><small>Ingrese con su usuario y contraseña</small></h4>
                            <br />
                            {this.props.location.state && _.map(this.props.location.state.mensajes, (e, i) => <Alert key={i} color={"warning"}>{e}</Alert>)}
                            <Login />
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        }
        return (
            <div className="detalle-cuenta-layout">
                <div className="detalle-sidebar d-none d-lg-block">
                    {Navegacion}
                </div>
                <div className="detalle-content">
                    <div className="d-lg-none mb-3">
                        <Button color="primary" onClick={() => this.setState({ collapsed: !this.state.collapsed })} className="w-100 d-flex justify-content-between align-items-center">
                            <span><i className={`fa ${this.state.collapsed ? 'fa-bars' : 'fa-times'} mr-2`} /> Menú de la Cuenta</span>
                            <i className={`fa fa-chevron-down transition-transform ${!this.state.collapsed ? 'rotate-180' : ''}`} />
                        </Button>
                        <Collapse isOpen={!this.state.collapsed}>
                            <div className="detalle-sidebar-mobile">
                                {Navegacion}
                            </div>
                        </Collapse>
                    </div>
                    <Card>
                        <CardHeader className="detalle-header">
                            <div className="header-main-row">
                                <div className="header-account-info">
                                    <div className="header-icon-container">
                                        <i className="fa fa-user-circle-o" />
                                    </div>
                                    <div>
                                        <h4 className="mb-0">
                                            <span className="font-weight-light">Cuenta</span> {Global.AgregaDV(servicio.idServicio)}
                                            <small className="d-block text-white-50">{servicio.nombreEmpresa}</small>
                                        </h4>
                                    </div>
                                </div>
                                <div className="header-debt-and-actions">
                                    {servicio.deuda_actual !== undefined &&
                                        <div className="debt-display">
                                            <small>Deuda <span className={servicio.deuda_vencida > 0 ? "debt-status-vencida" : "debt-status-actual"}>{servicio.deuda_vencida > 0 ? "Vencida" : "Actual"}</span></small>
                                            <div className="monto">$ {Global.FormatearNumero(servicio.deuda_actual)}</div>
                                        </div>
                                    }
                                    {servicio.deuda_actual > 0 &&
                                        <Button tag={Link} to={{ pathname: "/paga", state: { servicio: servicio.idServicio, empresa: servicio.empresa } }} color="light" outline className="ml-md-3">Pagar</Button>
                                    }
                                </div>
                            </div>
                            <div className="header-secondary-row">
                                <div className="header-details">
                                    {servicio.nom_cliente && <div><strong>Titular:</strong> {Global.toTitleCase(servicio.nom_cliente)}</div>}
                                    {servicio.dir_instal && <div><strong>Dirección:</strong> {Global.toTitleCase(servicio.dir_instal)}, {Global.toTitleCase(servicio.comuna_instal)}</div>}
                                </div>
                                {this.state.medidorInfo &&
                                    <div className="header-meter-info">
                                        <div className="meter-status">
                                            <i className={`fa fa-2x ${this.state.medidorInfo.b_lectura_remota ? 'fa-wifi' : 'fa-tachometer'}`} />
                                            <small>{this.state.medidorInfo.b_lectura_remota ? 'Medidor Inteligente' : 'Medidor Convencional'}</small>
                                        </div>
                                    </div>
                                }
                            </div>
                        </CardHeader>
                        {servicio.estado_corte && !servicio.estado_corte?.toLowerCase()?.includes("no afecto") ?
                            <Alert color="danger" className="status-corte-alert">
                                <i className="fa fa-warning mr-2"/>Estado Corte: {servicio.estado_corte}
                            </Alert>:null
                        }
                        <CardBody className="cuerpo-modal">
                            <Switch>
                                {
                                    React.Children.map(this.props.children, child => {
                                        return React.cloneElement(child, { passedProps: { Convenios: this.state.Convenios, Usuario: this.props.Usuario, Servicio: this.props.location.state ? this.props.location.state.servicio : {}, medidorInfo: this.state.medidorInfo } })
                                    })
                                }
                            </Switch>
                        </CardBody>
                    </Card>
                </div>
            </div>
        )
    }
}


export default withRouter(Detalle);